import { IconeHistorique } from '@/components/historique/icone-historique';
import { Button, Icon } from '@pms-digital/design-system';
import { NOYAUX, type NoyauCode } from '@rosetta/shared';

interface CarteNonAboutieProps {
  noyau: NoyauCode;
  /** Opens the input screen with this text and the noyaux that did not succeed. */
  onRelancer: () => void;
}

/**
 * The card of a noyau whose translation did not succeed, in a partial translation (#13): the
 * same white card in its grey frame, without the colour of the noyau (there is no text of it to
 * show), the `error` icon, a sentence that names the noyau, and "relancer".
 */
export function CarteNonAboutie({ noyau, onRelancer }: CarteNonAboutieProps) {
  const { famille, variante } = NOYAUX[noyau];
  return (
    <article
      aria-label="traduction non aboutie"
      className="box-border flex w-full flex-col items-start gap-6 rounded-lg border border-gray-200 bg-white px-8 py-8"
    >
      <p className="flex items-start gap-3 text-body leading-[1.5]">
        <span className="mt-px inline-flex shrink-0 text-rouge-deep">
          <Icon name="error" size={24} />
        </span>
        <span>
          La traduction vers{' '}
          <span className="font-semibold">
            {famille} {variante} ({noyau})
          </span>{' '}
          n'a pas abouti.
        </span>
      </p>
      <Button type="button" variant="primary" onClick={onRelancer}>
        <IconeHistorique name="refresh" size={20} />
        relancer
      </Button>
    </article>
  );
}
